/** @jsxImportSource @emotion/react */
import { mtgWhiteBackgroundUktk } from "assets/css/shchMtmr";
import { memo } from "react";

/**
 * カード
 * @param {String} children 子要素
 */
const CardUktk = memo(({ children }) => {
  return <div css={mtgWhiteBackgroundUktk}>{children}</div>;
});

export default CardUktk;
